import React from 'react';

export type TFetchPriority = 'high' | 'low' | 'auto';

export type TFetchPriorityProps = {
  fetchPriority?: TFetchPriority;
  /** @deprecated Use fetchPriority instead. */
  fetchpriority?: TFetchPriority;
};

export const resolveFetchPriority = ({
  fetchPriority,
  fetchpriority,
}: TFetchPriorityProps): TFetchPriority | undefined => fetchPriority ?? fetchpriority;

export const getFetchPriorityDOMProps = ({
  fetchPriority,
  fetchpriority,
}: TFetchPriorityProps): Partial<Record<'fetchPriority' | 'fetchpriority', TFetchPriority>> => {
  const resolvedFetchPriority = resolveFetchPriority({ fetchPriority, fetchpriority });

  if (!resolvedFetchPriority) {
    return {};
  }

  const reactUse = (React as unknown as { use?: unknown }).use;

  // Match Next.js: React 19+ recognizes camelCase, React 18 still wants lowercase.
  return reactUse ? { fetchPriority: resolvedFetchPriority } : { fetchpriority: resolvedFetchPriority };
};
